module.exports = __webpack_public_path__ + "img/selected1-min.51de752b.png";